import { render } from "./Navbar.vue?vue&type=template&id=9574a132&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=9574a132&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9574a132"

export default script